




































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { Popup } from '@questelservices/common-vue';
import { DxButton, DxTextBox, DxCheckBox } from 'devextreme-vue';
import { DxValidator, DxCustomRule, DxRequiredRule } from 'devextreme-vue/validator';
import { DxToolbarItem } from 'devextreme-vue/popup';
import { DxScrollView } from 'devextreme-vue/scroll-view';  
import { ClientService } from '@/service/ClientService';
import notify from 'devextreme/ui/notify';
import { Prop } from 'vue-property-decorator';
import { confirm, alert } from 'devextreme/ui/dialog';
import { ClientDto } from '@/models/client/ClientDto';    
import { CreateClientDto } from '@/models/client/CreateClientDto';       
import DxValidationGroup from 'devextreme-vue/validation-group'
import ValidationGroup from "devextreme/ui/validation_group";    
import _ from 'lodash';

@Component({
    components: {
        DxButton,            
        Popup,            
        DxTextBox,            
        DxToolbarItem,  
        DxCheckBox,    
        DxValidator,
        DxCustomRule,
        DxScrollView,            
        DxValidationGroup,
        DxRequiredRule
    }
})
export default class CreateClientForm extends Vue {
    public $refs: Vue['$refs'] & {
        validationGroupRef? : ValidationGroup;
    } = {};
    
    @Prop({ default: false })
    showDialog!: boolean;        

    clientService = new ClientService();

    clients: ClientDto[] = []; 

    newClientName: string = "";
    initialBatchName: string = "0";
    addDefaultFeeRules: boolean = true; 

    get showingDialog() {
        return this.showDialog;
    }

    set showingDialog(value) {
        this.$emit("hiding");
    }

    @Watch("showDialog")
    onPropertyChanged(value: boolean, oldValue: boolean) {        
        if (value) {      
            this.validationGroup.reset();    
            this.newClientName = "";
            this.addDefaultFeeRules = true;                
        }                        
    }   

    onPopupShowing() {
        this.initialBatchName = "0";
    }

    private get validationGroup() {
        return ((this.$refs.validationGroupRef as ValidationGroup).instance as any); 
    }
   
    constructor() {
        super();                        
        this.loadData();       
    }        

    async loadData() {
        let clientService = new ClientService();
        this.clients = await clientService.getAll();
    }       

    hidingCreate() {
        this.showingDialog = false;
    }

    async confirmSave() {
        let validation = this.validationGroup.validate();
        if(!validation.isValid){
            return;
        }

        if (this.clients.some(c => c.ClientName.toLowerCase() == this.newClientName.trim().toLowerCase())) {
            alert("A client already exists with this name. Please choose a different client name", "Client already exists");
            return;
        }

        let confirmMessage = "Are you sure you want to create the client ";
        if (this.addDefaultFeeRules) {
            confirmMessage += `${this.newClientName} and add default fee type rules for them?`;
        }
        else {
            confirmMessage += `${this.newClientName}?`;
        }

        var result = confirm(confirmMessage, "Create New Client");
        result
            .then(dialogResult => {
                if(dialogResult) {
                    let createClientDto: CreateClientDto = {
                        ClientName: this.newClientName,
                        InitialBatchName: this.initialBatchName,
                        AddDefaultFeeRules: this.addDefaultFeeRules
                    }

                    this.clientService.createClient(createClientDto)
                        .then(_ =>{
                            this.loadData();
                            this.hidingCreate();
                            notify(`Successfully created new client ${this.newClientName}`, "success", 4000);
                        }); 
                }
            }
        );                        
    }
}
